import { defineMessages } from 'react-intl';

export default defineMessages({
  create: {
    id: 'pages.pdp.create',
    defaultMessage: 'Create Development Plan',
  },

  // Section titles
  generalInformation: {
    id: 'pages.pdp.generalInformation',
    defaultMessage: 'General Information',
  },

  // Form placeholders
  enterPdpName: {
    id: 'pages.pdp.enterPdpName',
    defaultMessage: 'Enter PDP name',
  },
  selectReviewCycle: {
    id: 'pages.pdp.selectReviewCycle',
    defaultMessage: 'Select a review cycle',
  },
  selectMotivationFactors: {
    id: 'pages.pdp.selectMotivationFactors',
    defaultMessage: 'Select motivation factors',
  },
  describeCareerAspirations: {
    id: 'pages.pdp.describeCareerAspirations',
    defaultMessage: 'Describe your career aspirations',
  },
  describeStrengthsAndImprovements: {
    id: 'pages.pdp.describeStrengthsAndImprovements',
    defaultMessage: 'Describe your current strengths and areas for improvement',
  },
  describeSupportRequired: {
    id: 'pages.pdp.describeSupportRequired',
    defaultMessage: 'Describe the support you need',
  },
  enterDevelopmentNeedName: {
    id: 'pages.pdp.enterDevelopmentNeedName',
    defaultMessage: 'Enter development need name',
  },
  enterActionStep: {
    id: 'pages.pdp.enterActionStep',
    defaultMessage: 'Enter action step',
  },
  enterTrainingName: {
    id: 'pages.pdp.enterTrainingName',
    defaultMessage: 'Enter training name',
  },
  addComment: {
    id: 'pages.pdp.addComment',
    defaultMessage: 'Add a comment...',
  },

  // Empty state messages
  noDevelopmentNeedsTitle: {
    id: 'pages.pdp.noDevelopmentNeedsTitle',
    defaultMessage: 'No development needs added yet',
  },
  noDevelopmentNeedsDescription: {
    id: 'pages.pdp.noDevelopmentNeedsDescription',
    defaultMessage:
      'Add development needs to identify areas where you want to grow and improve',
  },
  noRequiredTrainingsTitle: {
    id: 'pages.pdp.noRequiredTrainingsTitle',
    defaultMessage: 'No required trainings added yet',
  },
  noRequiredTrainingsDescription: {
    id: 'pages.pdp.noRequiredTrainingsDescription',
    defaultMessage: 'Add required trainings to identify learning opportunities',
  },
  noActionStepsTitle: {
    id: 'pages.pdp.noActionStepsTitle',
    defaultMessage: 'No action steps added yet',
  },
  noActionStepsDescription: {
    id: 'pages.pdp.noActionStepsDescription',
    defaultMessage:
      'Add action steps to break down your development need into manageable tasks',
  },

  // Accessibility labels
  deleteTraining: {
    id: 'pages.pdp.deleteTraining',
    defaultMessage: 'Delete training',
  },
  deleteActionStep: {
    id: 'pages.pdp.deleteActionStep',
    defaultMessage: 'Delete action step',
  },
});
